module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v(_vm._s(_vm.location))])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.detail))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17f93402!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/contact/HomeContactContent.vue
// module id = 137
// module chunks = 1